import React, {memo, useContext} from 'react';
import './CartDisplay.less';
import {ListSplitter} from 'elements/list-splitter/ListSplitter.tsx';
import {CartItems} from '../cart-items/CartItems.tsx';

import {CartTotal} from 'elements/cart-total/CartTotal';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const CartDisplay = memo(({
																	 cartItems,
																	 isReadOnly,
																	 onQuantityDecClick,
																	 onQuantityIncClick,
																	 onModifierGroupClick,
																	 serviceFeePercent,
																	 serviceFee,
																	 subtotal,
																	 delivery,
																	 deliveryVat = null,
																	 deliveryVatPercent = null,
																	 discount,
																	 cashpointsName,
																	 cashpoints,
																	 tip,
																	 vat,
																	 total,
																	 isNoPaddings = false,
																	 isHighlightTotal = false
																 }) => {

	const translations = useContext(TranslationsContext);

	return (
		<div className={`cart-display ${
			isNoPaddings ? 'cart-display--no-paddings' : ''
		} ${
			isHighlightTotal ? 'cart-display--highlight-total' : ''
		}`}>
			<div className="cart-display__items">
				<CartItems
					cartItems={cartItems}
					onQuantityDecClick={onQuantityDecClick}
					onQuantityIncClick={onQuantityIncClick}
					onModifierGroupClick={onModifierGroupClick}
					isReadOnly={isReadOnly}
					isAlignByContainer
				/>
			</div>

			{(!!serviceFee || !!subtotal || !!discount || !!cashpoints || !!total) && <ListSplitter isAlignByContainer/>}

			<ul className="cart-display__totals">
				{serviceFee && (
					<div className="cart-display__total">
						<CartTotal
							name={getSafeTranslation('CartDisplay.serviceFeeLabel', translations).replace('{percent}', serviceFeePercent)}
							price={serviceFee}
							isSubtotal
						/>
					</div>
				)}
				{subtotal && (
					<div className="cart-display__total">
						<CartTotal
							name={getSafeTranslation('CartDisplay.subTotalLabel', translations)}
							price={subtotal}
							isSubtotal
						/>
					</div>
				)}
				{
					((typeof delivery === 'string' && delivery.length > 0) || (typeof delivery === 'number' && delivery > 0)) && (
						<div className="cart-display__total">
							<CartTotal
								name={getSafeTranslation('CartDisplay.deliveryPriceLabel', translations)}
								price={delivery}
								isSubtotal
							/>
						</div>
					)
				}
				{
					((typeof deliveryVat === 'string' && deliveryVat.length > 0) || (typeof deliveryVat === 'number' && deliveryVat > 0)) && (
						<div className="cart-display__total">
							<CartTotal
								name={
									getSafeTranslation('CartDisplay.deliveryVatLabel', translations)
										.replace('{percent}', deliveryVatPercent)
								}
								price={deliveryVat}
								isSubtotal
							/>
						</div>
					)
				}
				{(typeof discount === 'string' || (typeof discount === 'number' && Math.abs(discount) > 0.00001)) && (
					<div className="cart-display__total">
						<CartTotal
							name={getSafeTranslation('CartDisplay.discountLabel', translations)}
							price={discount}
							isSubtotal
						/>
					</div>
				)}
				{typeof cashpoints === 'number' && cashpoints > 0 && (
					<div className="cart-display__total">
						<CartTotal name={cashpointsName} price={-cashpoints} isSubtotal/>
					</div>
				)}
				{
					((typeof tip === 'string' && tip.length > 0) || (typeof tip === 'number' && tip > 0)) && (
						<div className="cart-display__total">
							<CartTotal
								name={getSafeTranslation('CartDisplay.tipLabel', translations)}
								price={tip}
								isSubtotal
							/>
						</div>
					)
				}
				{((typeof vat === 'string' && vat.length > 0) || (typeof vat === 'number' && vat > 0)) && (
					<div className="cart-display__total">
						<CartTotal
							name={getSafeTranslation('CartDisplay.vatLabel', translations)}
							price={vat}
							isSubtotal
						/>
					</div>
				)}
				{typeof total === 'number' && (
					<div className="cart-display__total">
						<CartTotal
							name={getSafeTranslation('CartDisplay.totalLabel', translations)}
							price={total}
						/>
					</div>
				)}
			</ul>
		</div>
	);
});
